import styled, { css } from 'styled-components'

export const Tabs = styled.div`
  display: flex;
  ${({ variant }) => variant === 'primary' && css`
    width: fit-content;
    border-radius: ${props => props?.theme?.utils?.radius?.m}px;
    background-color: #F8F9FA;
    color: ${props => props?.theme?.colors?.darkGreen};
  `}

  ${({ variant }) => variant === 'secundary' && css`
    color: ${props => props?.theme?.colors?.darkTextColor};
  `}

  ${({ variant }) => variant === 'primaryContrast' && css`
    color: ${props => props?.theme?.colors?.white};
  `}

  ${({ disableBackground }) => disableBackground && css`
    background-color: transparent;
  `}
`

export const Tab = styled.div`
  border-radius: ${props => props?.theme?.utils?.radius?.m}px;
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.3s ease;

  ${({ active }) => active && css`
    background-color: ${props => props?.variant === 'primaryContrast' ? props?.theme?.colors?.darkGreen : props?.theme?.colors?.lightGreen};
    ${({ borderBottom }) => borderBottom && css`
      border-bottom: 1px solid;
    `}
  `}

  ${({ active }) => !active && css`
    &:hover {
      transform: translateY(-4px);
    }
    color: ${props => props?.variant === 'primaryContrast' ? props?.theme?.colors?.black : props?.theme?.colors?.darkGray};
  `}

  ${({ boldText }) => boldText && css`
    font-weight: 600;
  `}

  ${({ padding }) => padding && css`
    padding: ${padding};
  `}
`
